module.exports = __webpack_public_path__ + "static/media/S (95).1b481e78.jpg";